// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wuWlQ","card-wrapper":"styles_card-wrapper__o34vU","close":"styles_close__m9XXe"};